import type { VignetteDefinition } from "./types";

/**
 * A common activity gated by the long arc (`minSimDay`) rather than
 * available from day one — Johnny starts building a raft. Once it first
 * plays, the raft prop stays visible permanently (no onExit hiding it) as
 * a persistent landmark of progress, until the escape-ending vignette
 * eventually sails off on it and the arc loops back to day 0.
 */
export const raftBuildingVignette: VignetteDefinition = {
  id: "raft-building",
  name: "Building a raft",
  category: "common",
  weight: 6,
  animationClip: "Interact",
  loopAnimation: true,
  durationMs: 6000,
  cameraFraming: {
    offset: { x: -2.5, y: 2, z: -1.5 },
    targetOffset: { x: 0.8, y: 0.5, z: 0.45 },
  },
  audioCues: [],
  minSimDay: 1,
  onEnter: (ctx) => ctx.decorator.setRaftVisible(true),
};
